import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { KPI } from '../../../../@core/api';
import { PerimetersService, QuotePartService, ScopeService, UsersService, SettingsService } from '../../../../@core/utils';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { SiteKwhConsumptionComponent } from '../site-kwh-consumption/site-kwh-consumption.component';
import { SiteReferenceDatasComponent } from '../site-reference-datas/site-reference-datas.component';
import { NbCardModule, NbTabsetModule } from '@nebular/theme';
import { AgGridDocumentsComponent } from '../../ag-grid-documents/ag-grid-documents.component';
import { SiteQuotePartComponent } from '../site-quote-part/site-quote-part.component';
import { SiteNotesComponent } from '../site-notes/site-notes.component';
import { SiteRefrigerantFluidsComponent } from '../site-refrigerant-fluids/site-refrigerant-fluids.component';
import { SiteObjectiveEnergyCarbonComponent } from '../site-objective-energy-carbon/site-objective-energy-carbon.component';

@Component({
  selector: 'app-site-main-info-tabs',
  templateUrl: './site-main-info-tabs.component.html',
  styleUrls: ['./site-main-info-tabs.component.scss'],
  standalone: true,
  imports: [
    NbTabsetModule,
    SiteReferenceDatasComponent,
    SiteKwhConsumptionComponent,
    TranslateModule,
    AsyncPipe,
    AgGridDocumentsComponent,
    SiteQuotePartComponent,
    SiteNotesComponent,
    SiteRefrigerantFluidsComponent,
    SiteObjectiveEnergyCarbonComponent,
    NbCardModule
  ]
})
export class SiteMainInfoTabsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() perimeter: KPI.Perimeter;
  @Input() perimeterStats: KPI.PerimeterStatsDetails;
  @Input() isFidjiAct: boolean = true;
  @Input() focusedPerimeterId: number | null = null;
  @Input() refreshKey: number = 0;
  public energyEnabled: boolean;
  public energyEnabled$: Observable<boolean> = this.scopeService.user$.pipe(
    map((user) => {
      const hasPermission = user.can_access_energy;
      const energyModuleEnabled = this.settingsService.settingMustBeTrue('ENERGY__ENABLE');
      return hasPermission && energyModuleEnabled;
    })
  );
  private subscriptions: Subscription[] = [];
  public selectedTabId;
  public photosEnabled: boolean = false;
  public profitsEnabled: boolean = false;
  public quotesEnabled: boolean;
  public perimeterIds: number[];
  public readOnly: boolean = false;

  constructor(
    private scopeService: ScopeService,
    private quotePartService: QuotePartService,
    private cdr: ChangeDetectorRef,
    private users: UsersService,
    private settingsService: SettingsService
  ) { }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.scopeService.user$.subscribe((user) => {
        this.energyEnabled = user.can_access_energy;
      }),
      this.quotePartService.getQuotePartEnabled().subscribe((enable) => {
        this.quotesEnabled = enable.enable;
        this.cdr.detectChanges();
      }),
      this.users.currentUserHasReadOnlyForSomePerimeters([this.perimeter.id]).subscribe(
        readOnlyPermissions => {
          this.readOnly = readOnlyPermissions?.length > 0;
        }
      )
    );

    this.updatePerimeterIds();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.perimeter && !changes.perimeter.firstChange) {
      this.updatePerimeterIds();
    }
  }

  private updatePerimeterIds(): void {
    this.perimeterIds = PerimetersService.getAllPerimetersIds([this.perimeter]);
  }

  public changeTab(event): void {
    this.selectedTabId = Number(event.tabId);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
